import React, { FC } from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';
import {
  KnowledgeBaseLink,
  KnowledgeBaseLinks,
} from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseLinks';

export const LearnMoreAboutVulnerabilityManagement: FC = () => {
  const links: KnowledgeBaseLink[] = [
    { label: 'Findings', field: 'findings' },
    { label: 'Issues', field: 'issues' },
    { label: 'Remediation', field: 'remediation' },
  ];

  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="vulnerability_management"
      headerTitle="Vulnerability Management"
      body={
        <Stack spacing={10}>
          <Stack spacing={4}>
            <Text fontWeight={600}>Description</Text>
            <Text>
              Ariksa provides agentless vulnerability management for virtual
              machines, containers, serverless functions and images. All
              supported resources are automatically scanned by deploying Ariksa
              Outpost, a virtual machine, within your cloud account (for
              security, cost efficiency and performance). Ariksa Outpost scans
              all resources in the region that it is deployed in.
            </Text>
            <Text pt={2}>
              Ariksa helps you prioritize patch management – reducing hundreds
              of thousands of CVEs to a handful of hosts that need attention
              based on multi-layered analysis that includes evaluating network
              exposure, identity risks, data access risks, threat modeling,
              threat hunting, and evaluating exploitability to name a few. This
              results in a massive reduction of operational effort and fatigue
              elimination while focusing cloud security efforts on only imminent
              risks and potential attack paths to your cloud.
            </Text>
            <Text pt={2}>
              Ariksa Outpost is deployed within your cloud account, so that data
              is analyzed in a secure way.
            </Text>
          </Stack>
          <KnowledgeBaseLinks links={links} />
        </Stack>
      }
    />
  );
};
